module.exports = __webpack_public_path__ + "static/media/gif_SE_step_4.5c680975.gif";